module.exports = __webpack_public_path__ + "assets/img/3006.2ae27e18.png";